import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import {
  ACCOUNT_USER_DETAIL_COUPON_HISTORY_LIST_FILTER_OPTION_MODEL,
  COUPON_GENERATE_VALID_RESULT_MODEL,
} from './models';
import couponToastMsg from '../../../../../constants/service/toastMsg/couponToastMsg';
import { useAccountUserCouponDetailQuery, useCheckValidGenerateCouponMutate } from './query';

export const useAccountUserCouponDetail = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_COUPON_HISTORY_LIST_FILTER_OPTION_MODEL);

  const { data } = useAccountUserCouponDetailQuery({
    userId,
    pagination,
    filterOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_COUPON_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.couponHistoryList.list,
        totalCnt: result.data.couponHistoryList.totalCnt,
      }),
    },
  });

  return { couponHistoryList: data, pagination, filterOption, setPagination, setFilterOption };
};

export const useCheckValidGenerateCoupon = ({ userId }) => {
  const {
    mutate,
    data: result,
    reset,
  } = useCheckValidGenerateCouponMutate({
    userId,
    options: {
      onSuccess: () => toastMsg.success(couponToastMsg.GET_ISSUED_COUPON_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  });

  return {
    checkValidGenerateCoupon: mutate,
    validResult: result?.data || COUPON_GENERATE_VALID_RESULT_MODEL,
    resetValidResult: reset,
  };
};
